import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    config: {},
    logged_in: false,
    isLoading: false,
    payload: {
      image: null,
      finished_image: null,
      mood: null
    },
    iOS: false,
    isSafari: false,
    standalone: false,
    imageSource: null,
    mobileDevice: false
  },
  mutations: {
    login (state, data) {
      state.logged_in = true
      state.config = data
    },
    logout (state) {
      state.logged_in = false
      state.config = {}
    },
    updatePayload (state, data) {
      state.payload.image = data
    },
    updateFinalImage (state, data) {
      state.payload.finished_image = data
    },
    updateMood (state, data) {
      state.payload.mood = data
    },
    updateIOS (state, data) {
      state.iOS = data
    }
  },
  actions: {

  }
})
